import { Competition } from 'business';
import { useQuery } from 'bridge';

export default function useSubCompetitions(parentCompetitionId?: string) : Competition[] | undefined {

    const subCompetitions : Competition[] | undefined = useQuery<Competition>({queryType: 'subCompetitions', parentCompetitionId});
    return subCompetitions;
}
